import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconInfoMulticoloredStyle0 = cosmosIconCss;

const CosmosIconInfoMulticolored$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconInfoMulticolored extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5ce2c1c0eaa598f8cf7db0bdc4c209595a11aa51', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1804440405a9bb3760dde56f1f0d76588fbf2643', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9f2d887424da4511d2e3809de400b0738f09cc52', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Z", fill: "currentColor", "fill-opacity": ".2" }), h("path", { key: 'a1d0644cf3d4f784fe2419e44ec0165bda1c155d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.25 8.56a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3 2.44v-.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-4h-2a.5.5 0 0 1-.5-.5Z", fill: "currentColor", "fill-opacity": ".6" }))));
    }
    static get style() { return CosmosIconInfoMulticoloredStyle0; }
}, [1, "cosmos-icon-info-multicolored", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-info-multicolored"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-info-multicolored":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInfoMulticolored$1);
            }
            break;
    } });
}

const CosmosIconInfoMulticolored = CosmosIconInfoMulticolored$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconInfoMulticolored, defineCustomElement };
